import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { useSelector } from 'react-redux';

const SELECT_MENU_Z_INDEX = 3600;

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    width: '215px',
    padding: '10px 0px',
    margin: '-8px 0 0 -5px',
  },
  textFieldNoWidth: {
    padding: '10px 0px',
    margin: '-8px 0 0 -5px',
  },
  dense: {
    marginTop: theme.spacing(2)
  },
  menu: {
    width: 100,
    top: '150px',
  },
  smallBox: {
    width: '14%',
    padding: '10px 0px',
    margin: '-8px 0 0 -5px',
    '& .MuiSelect-iconOutlined': {
      right: '0px'
    }
  },
  whiteText: {
    color: 'white',
  },
   inputLight: {
     color: 'black',  // Color for the input text
  },
  inputdark: {
    color: 'white',
  },
  outlinedWhite: {
    '& .MuiOutlinedInput-root': {
      borderColor: 'white',
      '& fieldset': {
        borderColor: 'white',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'white',
      },
      '&.Mui-disabled': {
        border: '0.5px solid #aeadad',
      },
    },
  },
  noPadding: {
    paddingTop: '0px !important',
    paddingBottom: '0px !important',
  },
  // The menu is as wide as the field, so long labels are cut off with an ellipsis.
  optionLabel: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }
}));

// Show the full label as a tooltip, but only when it is actually truncated.
const showTitleIfTruncated = (e) => {
  const el = e.currentTarget;
  el.title = el.scrollWidth > el.clientWidth ? el.textContent : '';
};

// Set on the open menu's paper, so scrolling inside the menu can be told apart from
// scrolling the page. A fixed attribute rather than a generated class name, so the
// selector never depends on how JSS names classes.
const MENU_PAPER_ATTR = 'data-selectbox-menu';

export default function SelectBox(props) {
  const classes = useStyles();
  const toggle = useSelector(state => state.setToggle.toggle);

  const items = props.items;
   const [open, setOpen] = useState(false);
  
    useEffect(() => {
      // Only an open menu needs to hear about scrolling.
      if (!open) {
        return undefined;
      }
      const handleScroll = (e) => {
        // Scrolling the menu's own list (see menuMaxHeight) must not close it.
        if (e.target instanceof Element && e.target.closest('[' + MENU_PAPER_ATTR + ']')) {
          return;
        }
        setOpen(false); // close dropdown when scrolling
      };

      window.addEventListener("scroll", handleScroll, true);
      return () => {
        window.removeEventListener("scroll", handleScroll, true);
      };
    }, [open]);
  return (
    <TextField
      id={props.id}
      name={props.name}
      select
      className={props.customClass === true ? `${props.className} ${classes.textFieldNoWidth}` : `${props.className} ${props.smallSelectBox ? classes.smallBox : classes.textField} ${toggle ? '' : classes.outlinedWhite}`}
      value={props.value}
      InputLabelProps={{ shrink: false }}
      InputProps={{
        classes: { input: toggle ? classes.inputLight : classes.inputdark },
      }}
      SelectProps={{
        open: open,
        onOpen: () => setOpen(true),
        onClose: () => setOpen(false),
        MenuProps: {
          style: {
            zIndex: props.menuZIndex || SELECT_MENU_Z_INDEX,
          },
          className: (props.customClass == true ? props.customMenuClass : (props.smallSelectBox ? "" : classes.menu)),
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left"
          },
          getContentAnchorEl: null,
          PaperProps: {
            [MENU_PAPER_ATTR]: '',
            style: {
              zIndex: props.menuZIndex || SELECT_MENU_Z_INDEX,
              // Optional cap so long lists scroll instead of running down the page,
              // with a scrollbar that matches the dark menu in dark theme.
              ...(props.menuMaxHeight ? { maxHeight: props.menuMaxHeight } : {}),
              ...(props.menuMaxHeight && !toggle ? { scrollbarColor: '#777 #292929' } : {}),
            }
          },
          classes: {
            list: classes.noPadding,  // Apply noPadding class to remove padding
          }
        },
        classes: { icon: toggle ? '' : classes.whiteText },
      }}
      margin={props.margin}
      variant={props.variant}
      onChange={props.onChange}
      disabled={props.disabled}
      onBlur={props.onBlur}
    >
      {(items && items.length > 0)
        ? items.map((option) => (
            <MenuItem 
            disabled={option.disabled ? option.disabled : false}
            key={option.value} value={option.value} style={toggle ? { color: '#292929', backgroundColor: '#ffffff' } : { color: '#ffffff', backgroundColor: '#292929' }}>
                {/* Labels are plain text unless the caller opts in with allowHtmlLabels for its
                    own fixed markup. Never opt in for labels users can name (saved views etc.):
                    the markup would run in every viewer's browser. */}
                {props.allowHtmlLabels && typeof option.label === "string" && /<[^>]+>/.test(option.label)
              ? <span className={classes.optionLabel} onMouseEnter={showTitleIfTruncated} dangerouslySetInnerHTML={{ __html: option.label }} />
              : <span className={classes.optionLabel} onMouseEnter={showTitleIfTruncated}>{option.label}</span>}
            </MenuItem>
          ))
        : (
            <MenuItem value="" disabled>
              No options available
            </MenuItem>
          )
      }
    </TextField>
  );
}